<template>
  <div>
    <div style="height: 190px">
      <div class="dashIcon">
        <img
          src="/images/flavor.png"
          alt="flavors"
          width="100%"
          height="100%"
        />
      </div>
      <div class="q-pt-md">
        <q-toggle label="Display Archived" v-model="displayArchived"></q-toggle>
      </div>
    </div>
    <q-separator color="black" />

    <div class="row items-center q-py-xs">
      <div class="col q-pl-sm">Flavor</div>
      <div
        class="col-auto"
        :style="`width: ${$q.screen.xs ? '88' : '112'}px`"
      ></div>
    </div>

    <q-separator color="black" />

    <div v-for="flavor in Flavors" :key="flavor.id">
      <div class="row items-center">
        <div class="col q-pl-sm">{{ decoder(flavor.name) }}</div>
        <div class="col-auto q-pa-sm">
          <q-btn
            unelevated
            icon="edit"
            size="md"
            :padding="$q.screen.xs ? '2px 4px' : '2px 10px'"
            color="grey-3"
            text-color="primary"
            class="q-mr-sm"
            @click="editFlavor(flavor)"
          >
          </q-btn>
          <q-btn
            v-if="!flavor.archived && flavor.transactions > 0"
            unelevated
            color="grey-3"
            text-color="accent"
            icon="archive"
            size="md"
            :padding="$q.screen.xs ? '2px 4px' : '2px 10px'"
            @click="archiveFlavor(flavor, true)"
          />
          <q-btn
            v-if="flavor.archived"
            unelevated
            icon="unarchive"
            size="md"
            color="grey-3"
            text-color="secondary"
            :padding="$q.screen.xs ? '2px 4px' : '2px 10px'"
            @click="archiveFlavor(flavor, false)"
          />
          <q-btn
            v-if="!flavor.archived && flavor.transactions === 0"
            unelevated
            color="grey-3"
            text-color="accent"
            icon="delete"
            size="md"
            :padding="$q.screen.xs ? '2px 4px' : '2px 10px'"
            @click="deleteFlavor(flavor)"
          />
        </div>
      </div>
      <q-separator />
    </div>

    <!-- Dialog Enter Flavor -->
    <q-dialog v-model="dialogFlavorEntry" persistent position="top">
      <q-card style="width: 400px">
        <div class="row items-center q-pa-md">
          <div class="col text-center text-h5">Flavor</div>
          <div class="col-auto">
            <q-btn icon="close" color="primary" v-close-popup />
          </div>
        </div>
        <q-separator />

        <q-form @submit="onSubmit" class="q-pa-md">
          <q-input
            outlined
            v-model="flavorObj.name"
            label="Name"
            maxlength="32"
            class="q-mb-md"
            hide-bottom-space
            :rules="[(value) => value !== '' || 'Name cannot be blank']"
          />

          <div class="row justify-end">
            <q-btn label="Submit" type="submit" color="primary" />
          </div>
        </q-form>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { decoder, cloneObj, upperCaseFirst } from '@/lib/helpers';
import store from '@/store';
const newFlavor = () => {
  return {
    id: 0,
    farm_id: store.getters.selectedFarm.id,
    fish_id: null,
    name: '',
    archived: false,
    transactions: 0,
    storeInfo: {}
  };
};

export default {
  name: 'Settings-Flavors',
  data() {
    return {
      decoder,
      dialogFlavorEntry: false,
      displayArchived: false,
      flavorObj: newFlavor()
    };
  },
  methods: {
    add() {
      this.flavorObj = newFlavor();

      this.dialogFlavorEntry = true;
    },
    archiveFlavor(flavor, value) {
      const flavorCopy = cloneObj(flavor);
      flavorCopy.archived = value;

      flavorCopy.storeInfo = {
        farmId: store.state.farm.id
      };

      this.$q
        .dialog({
          title: 'Archive Flavor',
          message: `Are you sure you want to ${
            value ? 'archive' : 'unarchive'
          } this flavor?`,
          ok: {
            color: 'accent',
            label: value ? 'Archive' : 'Unarchive',
            icon: value ? 'archive' : 'unarchive'
          },
          cancel: {
            color: 'grey-2',
            textColor: 'primary',
            label: 'cancel',
            icon: 'close'
          },
          focus: 'none',
          persistent: true
        })
        .onOk(() => {
          this.archiveFlavorConfirmed(flavorCopy);
        });
    },
    archiveFlavorConfirmed(flavor) {
      store
        .dispatch('updateFlavor', {
          flavor
        })
        .then((results) => {
          this.$finishResult.handleResultsAsync(results);
        });
    },
    deleteFlavor(flavor) {
      flavor.storeInfo = {
        farmId: store.state.farm.id
      };

      this.$q
        .dialog({
          title: 'Delete Flavor',
          message: `Are you sure you want to delete this flavor?`,
          ok: {
            color: 'accent',
            label: 'Delete',
            icon: 'delete'
          },
          cancel: {
            color: 'grey-2',
            textColor: 'primary',
            label: 'cancel',
            icon: 'close'
          },
          focus: 'none',
          persistent: true
        })
        .onOk(() => {
          this.deleteFlavorConfirmed(flavor);
        });
    },
    deleteFlavorConfirmed(flavor) {
      store
        .dispatch('deleteFlavor', {
          flavor
        })
        .then((results) => {
          this.$finishResult.handleResultsAsync(results);
        });
    },
    editFlavor(flavor) {
      this.flavorObj = cloneObj(flavor);
      this.flavorObj.name = decoder(this.flavorObj.name);
      this.dialogFlavorEntry = true;
    },
    onSubmit() {
      let dispatch;
      if (this.flavorObj.id === 0) {
        dispatch = 'createFlavor';
      } else {
        dispatch = 'updateFlavor';
      }

      this.flavorObj.name = upperCaseFirst(this.flavorObj.name);

      this.flavorObj.storeInfo = {
        farmId: store.state.farm.id
      };

      store
        .dispatch(dispatch, {
          flavor: this.flavorObj
        })
        .then((results) => {
          this.$finishResult.handleResultsAsync(results);
        });

      this.dialogFlavorEntry = false;
    }
  },
  computed: {
    Flavors() {
      let flavors = cloneObj(this.$store.state.farm.flavors);
      if (!this.displayArchived) {
        flavors = flavors.filter((element) => !element.archived);
      }

      return flavors.sort((a, b) => a.name.localeCompare(b.name));
    }
  }
};
</script>

<style scoped></style>
